import { LinearProgress, LinearProgressProps, makeStyles } from "@material-ui/core";
import clsx from "clsx";
import * as React from "react";

import { semanticColors } from "@/designTokens";

const useStyles = makeStyles({
  complete: { "& .MuiLinearProgress-bar": { backgroundColor: semanticColors["status/success"] } },
});
interface ProgressBarProps extends LinearProgressProps {
  complete?: boolean;
}
export const ProgressBar: React.FC<ProgressBarProps> = ({ complete = false, className, ...props }) => {
  const classes = useStyles();
  return (
    <LinearProgress
      variant="determinate"
      value={0}
      {...props}
      className={clsx(complete && classes.complete, className)}
    />
  );
};
